import styled from 'styled-components';
import { Layout } from 'antd';

export const StyledLayout = styled(Layout)`
  background-color: ${({ theme }) => theme.color.backgroundLight1};
  min-height: 100vh;
  
  h4.ant-typography {
    color: ${({ theme }) => theme.color.grey1};
    font-weight: 500;
    margin-top: 5px;
  }
  
  h5.ant-typography {
    color: ${({ theme }) => theme.color.grey1};
    font-weight: 500;
    margin-top: 5px;
    font-size: 18px;
  }
  
  .ant-typography {
    strong {
      font-weight: 500;
    }
  }
`;
